import BaseModulePlugins from '@/store/baseModule/plugins';
import techniciansModule from '@/store/modules/technicians/module';
import makeListRequest from '@/store/modules/technicians/makeQueryParams';

export default (store) => {
  store.registerModule(
    ['actions', 'technicians'],
    techniciansModule({ makeListRequest, obsoleteAllowed: true })
  );

  const basePlugin = new BaseModulePlugins({
    module: 'actions/technicians',
    store,
  });

  basePlugin.initAttributeFiltersWhenAttributesObjRefIsLoaded({});
};
